import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React from 'react';
export class ContextMenuItemSeparator extends React.Component {
    render() {
        return _jsx("div", { className: "new-context-menu-separator" });
    }
}
